export default {
  paymentManagement: "決済種別管理",
  newpayment: "支払ブランドを追加",
  nowUsing: "利用中",
  tipsForApplyingWallet:
    "支払ブランドの追加申請はMARSシステムにログインの上行って下さい。※ログインアカウントが不明な場合はカスタマサポート(03-4589-7746)までご連絡ください。",
  tipsForRmApplyingWallet:
    "支払いブランド追加ご希望の場合、リージョナルマーケティング（011-215-1002）へお問い合わせ下さい。"
};
